export const courses = {
  "general": {
    "name": "日常英語",
    "available": "日常英語,子ども向け一般英語,TOEIC,英検(2級以下),国連英検,ケンブリッジ英検",
    "plans": [
      {
        "title": "月2回プラン",
        "description": "50分 × 月2回<br /> (2週間に1回)",
        "price": "16,720",
        "discountLabel": "月額費用が <br /> 最も低いプラン",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "8,360",
        "feature": "低費用で始めたい方",
        "minLessons": "月2",
        "makeupLessons": "月1回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "月4回プラン",
        "description": "50分 × 月4回<br /> (1週間に1回)",
        "price": "31,680",
        "discountLabel": "レッスン単価が<span class='discount-highlight'>5.3%お得！</span>",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "23,760",
        "feature": "一番人気の定番プラン",
        "minLessons": "月4",
        "makeupLessons": "月2回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "月8回プラン",
        "description": "50分 × 月8回<br /> (1週間に2回)",
        "price": "61,160",
        "discountLabel": "レッスン単価が<span class='discount-highlight'>8.6%お得！</span>",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "53,515",
        "feature": "本格的に英語学習",
        "minLessons": "月8",
        "makeupLessons": "月3回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "月12回プラン",
        "description": "50分 × 月12回<br /> (1週間に3回)",
        "price": "89,100",
        "discountLabel": "レッスン単価が<span class='discount-highlight'>11.2%お得！</span>",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "81,675",
        "feature": "高頻度で効率良く学習",
        "minLessons": "月12",
        "makeupLessons": "月4回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "一括購入 (8~19回)",
        "description": "50分 × 8回~",
        "price": "63,360",
        "discountUnit": "price",
        "discountAmount": "5000",
        "discountedPrice": "58,360",
        "feature": "少ないレッスン数を短期間で受講",
        "minLessons": "8",
        "makeupLessons": "4回~",
        "period": "2ヶ月",
        "monthly": false
      },
      {
        "title": "一括購入 (20回~)",
        "description": "50分 × 20回~",
        "price": "148,500",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "138,500",
        "feature": "一括購入でお得に受講",
        "minLessons": "20",
        "makeupLessons": "月のレッスン回数により変化",
        "period": "12ヶ月",
        "monthly": false
      }
    ]
  },
  "general_business_english": {
    "name": "一般ビジネス英語",
    "available": "一般ビジネス英語,TOEIC,VERSANT",
    "plans": [
      {
        "title": "月2回プラン",
        "description": "50分 × 月2回<br /> (2週間に1回)",
        "price": "16,720",
        "discountLabel": "月額費用が <br /> 最も低いプラン",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "8,360",
        "feature": "低費用で始めたい方",
        "minLessons": "月2",
        "makeupLessons": "月1回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "月4回プラン",
        "description": "50分 × 月4回 <br /> (1週間に1回)",
        "price": "31,680",
        "discountLabel": "レッスン単価が<span class='discount-highlight'>5.3%お得！</span>",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "23,760",
        "feature": "一番人気の定番プラン",
        "minLessons": "月4",
        "makeupLessons": "月2回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "月8回プラン",
        "description": "50分 × 月8回<br /> (1週間に2回)",
        "price": "61,160",
        "discountLabel": "レッスン単価が<span class='discount-highlight'>8.6%お得！</span>",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "53,515",
        "feature": "本格的に英語学習",
        "minLessons": "月8",
        "makeupLessons": "月3回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "月12回プラン",
        "description": "50分 × 月12回<br /> (1週間に3回)",
        "price": "89,100",
        "discountLabel": "レッスン単価が<span class='discount-highlight'>11.2%お得！</span>",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "81,675",
        "feature": "高頻度で効率良く学習",
        "minLessons": "月12",
        "makeupLessons": "月4回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "一括購入 (8~19回)",
        "description": "50分 × 8回~",
        "price": "63,360",
        "discountUnit": "price",
        "discountAmount": "5000",
        "discountedPrice": "58,360",
        "feature": "少ないレッスン数を短期間で受講",
        "minLessons": "8",
        "makeupLessons": "4回~",
        "period": "2ヶ月",
        "monthly": false
      },
      {
        "title": "一括購入 (20回~)",
        "description": "50分 × 20回~",
        "price": "148,500",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "138,500",
        "feature": "一括購入でお得に受講",
        "minLessons": "20",
        "makeupLessons": "月のレッスン回数により変化",
        "period": "12ヶ月",
        "monthly": false
      }
    ]
  },
  "specialized_business_english": {
    "name": "特化型ビジネス英語",
    "available": "業種特化英語,専門分野英語,駐在員,管理職,国際機関,外交官,医者,弁護士,会計士,税理士,研究者,エンジニア",
    "plans": [
      {
        "title": "特化型ビジネス英語",
        "description": "50分 × 12回~",
        "price": "116,160",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "106,160",
        "feature": "業種や業界特化や上級者向けのレッスン",
        "minLessons": "12",
        "makeupLessons": "6回~",
        "period": "6ヶ月",
        "monthly": false
      }
    ]
  },
  "executive_business_english": {
    "name": "エグゼクティブ英語",
    "available": "経営者,会社役員",
    "plans": [
      {
        "title": "エグゼクティブ英語",
        "description": "50分 × 12回~",
        "price": "198,000",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "188,000",
        "feature": "エグゼクティブ向けのプレミアムレッスン",
        "minLessons": "12",
        "makeupLessons": "6回~",
        "period": "6ヶ月",
        "monthly": false
      }
    ]
  },
  "ielts": {
    "name": "IELTS",
    "available": "Speaking,Listening,Writing,Reading",
    "plans": [
      {
        "title": "IELTS対策",
        "description": "50分 × 8回~",
        "price": "77,440",
        "discountUnit": "price",
        "discountAmount": "5000",
        "discountedPrice": "72,440",
        "feature": "IELTS対策の専門レッスン",
        "minLessons": "8",
        "makeupLessons": "4回~",
        "period": "4ヶ月",
        "monthly": false
      },
      {
        "title": "IELTS対策 (元試験官)",
        "description": "50分 × 8回~",
        "price": "123,200",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "113,200",
        "feature": "IELTS元試験官によるプレミアムレッスン",
        "minLessons": "8",
        "makeupLessons": "6回~",
        "period": "4ヶ月",
        "monthly": false,
        "consultant": "あり"
      }
    ]
  },
  "toefl": {
    "name": "TOEFL",
    "available": "iBT,PBT,CBT,ITP",
    "plans": [
      {
        "title": "TOEFL対策",
        "description": "50分 × 8回~",
        "price": "77,440",
        "discountUnit": "price",
        "discountAmount": "5000",
        "discountedPrice": "72,440",
        "feature": "TOEFL対策の専門レッスン",
        "minLessons": "8",
        "makeupLessons": "4回~",
        "period": "4ヶ月",
        "monthly": false
      }
    ]
  },
  "eiken_pre1over": {
    "name": "英検準1級以上",
    "available": "英検準1級,英検1級",
    "plans": [
      {
        "title": "英検準1級以上",
        "description": "50分 × 8回~",
        "price": "77,440",
        "discountUnit": "price",
        "discountAmount": "5000",
        "discountedPrice": "72,440",
        "feature": "英検準1級以上の対策専門レッスン",
        "minLessons": "8",
        "makeupLessons": "4回~",
        "period": "4ヶ月",
        "monthly": false
      }
    ]
  },
  "alevel": {
    "name": "A-Level",
    "available": "English Language (英語),Maths(数学),Psychology (心理学),General Paper(論文学),Thinking Skills (思考能力)",
    "plans": [
      {
        "title": "A-Level (英語)",
        "description": "50分 × 12回~",
        "price": "184,800",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "174,800",
        "feature": "A-Levelの英語対策",
        "minLessons": "12",
        "makeupLessons": "6回~",
        "period": "6ヶ月",
        "monthly": false,
        "consultant": "あり"
      },
      {
        "title": "A-Level (英語以外)",
        "description": "50分 × 8回~",
        "price": "202,400",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "192,400",
        "feature": "Math/Science/Computer Scienceなどの英語以外の対策",
        "minLessons": "8",
        "makeupLessons": "6回~",
        "period": "4ヶ月",
        "monthly": false,
        "consultant": "あり"
      }
    ]
  },
  "uniprep": {
    "name": "大学入試",
    "available": "海外大学,国内大学AO入試,帰国子女推薦",
    "plans": [
      {
        "title": "大学入試面接/エッセイ (一般レベル)",
        "description": "50分 × 12回~",
        "price": "184,800",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "174,800",
        "feature": "海外/日本国内大学の英語面接やエッセイ対策",
        "minLessons": "12",
        "makeupLessons": "2回~",
        "period": "3ヶ月",
        "monthly": false,
        "consultant": "あり"
      },
      {
        "title": "大学入試面接/エッセイ (トップレベル)",
        "description": "50分 × 12回~",
        "price": "303,600",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "293,600",
        "feature": "Oxford大学やCambridge大学を始めとした海外トップレベル大学の英語面接やエッセイ対策",
        "minLessons": "12",
        "makeupLessons": "2回~",
        "period": "3ヶ月",
        "monthly": false,
        "consultant": "あり"
      }
    ]
  },
  "ib": {
    "name": "IB (国際バカロレア)",
    "available": "Language Acquisition (言語習得),Sciences (自然科学),Mathematics (数学),Individuals and Societies (個人と社会)",
    "plans": [
      {
        "title": "IB (英語)",
        "description": "50分 × 12回~",
        "price": "184,800",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "174,800",
        "feature": "IBの英語対策",
        "minLessons": "12",
        "makeupLessons": "6回~",
        "period": "6ヶ月",
        "monthly": false,
        "consultant": "あり"
      },
      {
        "title": "IB (英語以外)",
        "description": "50分 × 12回~",
        "price": "303,600",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "293,600",
        "feature": "Math/Scienceなどの英語以外の対策",
        "minLessons": "12",
        "makeupLessons": "6回~",
        "period": "4ヶ月",
        "monthly": false,
        "consultant": "あり"
      }
    ]
  },
  "teap": {
    "name": "TEAP",
    "available": "Speaking,Listening,Writing,Reading",
    "plans": [
      {
        "title": "TEAP",
        "description": "50分 × 12回~",
        "price": "184,800",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "174,800",
        "feature": "TEAP対策",
        "minLessons": "12",
        "makeupLessons": "6回~",
        "period": "6ヶ月",
        "monthly": false
      }
    ]
  },
  "schools": {
    "name": "インター/ボーディングスクール",
    "available": "入試対策,定期テスト対策,保護者インタビュー",
    "plans": [
      {
        "title": "インターナショナルスクール対策",
        "description": "50分 × 12回~",
        "price": "184,800",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "174,800",
        "feature": "入試対策、合格後の準備、在学中の学習サポート、各種試験対策",
        "minLessons": "12",
        "makeupLessons": "8回~",
        "period": "6ヶ月",
        "monthly": false,
        "consultant": "あり"
      },
      {
        "title": "ボーディングスクール対策",
        "description": "50分 × 12回~",
        "price": "303,600",
        "discountUnit": "price",
        "discountAmount": "20000",
        "discountedPrice": "283,600",
        "feature": "入試対策、合格後の準備、在学中の学習サポート、各種試験対策",
        "minLessons": "12",
        "makeupLessons": "8回~",
        "period": "6ヶ月",
        "monthly": false,
        "consultant": "あり"
      }
    ]
  },
  "specialized": {
    "name": "専門分野/特殊カリキュラム",
    "available": "",
    "plans": [
      {
        "title": "専門分野/特殊カリキュラム",
        "description": "50分 × 12回~",
        "price": "198,000",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "188,000",
        "feature": "高度にカスタマイズされたカリキュラムが必要となるレッスン",
        "minLessons": "12",
        "makeupLessons": "8回~",
        "period": "6ヶ月",
        "monthly": false,
        "consultant": "あり"
      }
    ]
  },
  "default": {
    "name": "日常英語/一般ビジネス英語",
    "available": "日常英語,子ども向け一般英語,TOEIC,英検(2級以下),国連英検,ケンブリッジ英検,一般ビジネス英語,TOEIC,VERSANT",
    "plans": [
      {
        "title": "月2回プラン",
        "description": "50分 × 月2回<br /> (2週間に1回)",
        "price": "16,720",
        "discountLabel": "月額費用が <br /> 最も低いプラン",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "8,360",
        "feature": "低費用で始めたい方",
        "minLessons": "月2",
        "makeupLessons": "月1回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "月4回プラン",
        "description": "50分 × 月4回<br /> (1週間に1回)",
        "price": "31,680",
        "discountLabel": "レッスン単価が<span class='discount-highlight'>5.3%お得！</span>",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "23,760",
        "feature": "一番人気の定番プラン",
        "minLessons": "月4",
        "makeupLessons": "月2回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "月8回プラン",
        "description": "50分 × 月8回<br /> (1週間に2回)",
        "price": "61,160",
        "discountLabel": "レッスン単価が<span class='discount-highlight'>8.6%お得！</span>",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "53,515",
        "feature": "本格的に英語学習",
        "minLessons": "月8",
        "makeupLessons": "月3回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "月12回プラン",
        "description": "50分 × 月12回<br /> (1週間に3回)",
        "price": "89,100",
        "discountLabel": "レッスン単価が<span class='discount-highlight'>11.2%お得！</span>",
        "discountUnit": "lesson",
        "discountAmount": "1",
        "discountedPrice": "81,675",
        "feature": "高頻度で効率良く学習",
        "minLessons": "月12",
        "makeupLessons": "月4回",
        "period": "2ヶ月~",
        "monthly": true
      },
      {
        "title": "一括購入 (8~19回)",
        "description": "50分 × 8回~",
        "price": "63,360",
        "discountUnit": "price",
        "discountAmount": "5000",
        "discountedPrice": "58,360",
        "feature": "少ないレッスン数を短期間で受講",
        "minLessons": "8",
        "makeupLessons": "4回~",
        "period": "2ヶ月",
        "monthly": false
      },
      {
        "title": "一括購入 (20回~)",
        "description": "50分 × 20回~",
        "price": "148,500",
        "discountUnit": "price",
        "discountAmount": "10000",
        "discountedPrice": "138,500",
        "feature": "一括購入でお得に受講",
        "minLessons": "20",
        "makeupLessons": "月のレッスン回数により変化",
        "period": "12ヶ月",
        "monthly": false
      }
    ]
  }
};
